const BASE_URL = "/api";
async function request(method, path, body) {
    const token = localStorage.getItem("token");
    const headers = {};
    if (body !== undefined) {
        headers["Content-Type"] = "application/json";
    }
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    const res = await fetch(`${BASE_URL}${path}`, {
        method,
        headers,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    if (res.status === 401) {
        // Try refresh
        const refreshToken = localStorage.getItem("refreshToken");
        if (refreshToken) {
            try {
                const refreshRes = await fetch(`${BASE_URL}/auth/refresh`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ refreshToken }),
                });
                if (refreshRes.ok) {
                    const data = await refreshRes.json();
                    localStorage.setItem("token", data.data.accessToken);
                    localStorage.setItem("refreshToken", data.data.refreshToken);
                    headers["Authorization"] = `Bearer ${data.data.accessToken}`;
                    const retryRes = await fetch(`${BASE_URL}${path}`, {
                        method,
                        headers,
                        body: body ? JSON.stringify(body) : undefined,
                    });
                    return retryRes.json();
                }
            }
            catch {
                // Refresh failed
            }
        }
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/";
    }
    return res.json();
}
export const api = {
    get: (path) => request("GET", path),
    post: (path, body) => request("POST", path, body),
    patch: (path, body) => request("PATCH", path, body),
    delete: (path) => request("DELETE", path),
};
